import React from 'react';
import { PDFViewer, Document, StyleSheet, Image } from '@react-pdf/renderer';
import { Page as PDFPage, Text, View as PDFView } from '@react-pdf/renderer';

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const styles = StyleSheet.create({
  page: {
    flexDirection: 'row',
    backgroundColor: '#E4E4E4'
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
    flex: 1,
    width: '400px',
    height: '300px',
    position: 'relative'
  },
  backgroundImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '110%',
    zIndex: -1
  },
  validFromText: {
    position: 'absolute',
    top: 0,
    right: 25,
    fontSize: 12,
    color: 'black',
    zIndex: 1,
    width: '30%'
  },
  container: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingBottom: 30
  },
  container2: {
    flex: 1,
    flexDirection: 'row'
  },
  mdfontSize: {
    fontSize: 15,
    color: 'black',
    zIndex: 1
  },
  cardNoContainer: {
    position: 'absolute',
    bottom: 5,
    left: '40%',
    transform: [{ translateX: -50 }],
    zIndex: 1,
    width: '100%'
  },
  cardNoText: {
    fontSize: 20,
    color: 'black'
  }
});

export const SchemeAllotmentPdf = ({ data }) => {
  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
  const { image } = data;
  const imageUrl = data.image.replace(/\\/g, '/').replace(/^.*[\\/]/, '/');
  return (
    <PDFViewer width="100%" height="500">
      <Document>
        <Page size="A4" style={styles.page}>
          <View style={styles.section}>
            <Image style={styles.backgroundImage} src="/back.png" />
            <View style={{ paddingTop: 10, ...styles.container }}>
              <Text style={styles.validFromText}>Valid Upto: {formatDate(data.scheme_valid_to)}</Text>
              <View style={{ padding: 15, width: '100%', flexDirection: 'row', justifyContent: 'space-between' }}>
                <View style={{ width: '45%' }}>
                  <View style={{ ...styles.container2, width: '100%' }}>
                    <View style={{ width: '100%' }}>
                      <Text style={styles.mdfontSize}>Name</Text>
                    </View>
                    <View style={{ width: '100%' }}>
                      <Text style={styles.mdfontSize}>:-{data.name}</Text>
                    </View>
                  </View>
                  <View style={{ ...styles.container2, paddingTop: 25, width: '100%' }}>
                    <View style={{ width: '100%' }}>
                      <Text style={styles.mdfontSize}>Age</Text>
                    </View>
                    <View style={{ width: '100%' }}>
                      <Text style={styles.mdfontSize}>:- {data.age}</Text>
                    </View>
                  </View>
                  <View style={{ ...styles.container2, paddingTop: 25, width: '100%' }}>
                    <View style={{ width: '100%' }}>
                      <Text style={styles.mdfontSize}>Gender</Text>
                    </View>
                    <View style={{ width: '100%' }}>
                      <Text style={styles.mdfontSize}>:- {data.gender}</Text>
                    </View>
                  </View>
                  <View style={{ ...styles.container2, paddingTop: 25, width: '100%' }}>
                    <View style={{ width: '100%' }}>
                      <Text style={styles.mdfontSize}>Mobile No</Text>
                    </View>
                    <View style={{ width: '100%' }}>
                      <Text style={styles.mdfontSize}>:- {data.mobile}</Text>
                    </View>
                  </View>
                  <View style={{ ...styles.container2, paddingTop: 25, width: '100%' }}>
                    <View style={{ width: '50%' }}>
                      <Text style={styles.mdfontSize}>Aadhar No</Text>
                    </View>
                    <Text style={styles.mdfontSize}> :-{data.aadhar}</Text>
                  </View>
                </View>
                <View style={{ width: '20%', marginRight: '10%' }}>
                  {/* Modify image style to have fixed width and height */}
                  <Image
                    style={{ width: 100, height: 100 }} // Fixed width and height
                    src={imageUrl}
                  />
                  {/* Commented the previous flexible style */}
                  {/* <Image style={{ width: "100%", height: "auto", paddingRight: "20%" }} src={imageUrl} /> */}
                </View>
              </View>
              <View style={styles.cardNoContainer}>
                <Text style={{ ...styles.cardNoText, color: 'white' }}>{data.card_no}</Text>
              </View>
            </View>
          </View>
        </Page>
      </Document>
    </PDFViewer>
  );
};
